<template>
    <v-dialog
        v-model="showDialog"
        :persistent="loading"
        width="600"
    >
        <v-card>
            <v-form
                v-if="data"
                ref="form"
                v-model="form"
                @submit.prevent="submitForm"
            >
                <v-card-title style="background-color: #009688; color: white;">
                    Delete &nbsp;<v-chip>{{ data.DIA_T }}</v-chip>&nbsp;from&nbsp;<v-chip>{{ data.UNLINK_NAME }}</v-chip>
                </v-card-title>
                <v-card-text>
                    <v-text-field
                        v-model.trim="data.DIA_T"
                        label="Diagnostic"
                        readonly
                    />
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn
                        color="teal darken-1"
                        outlined
                        width="120"
                        :disabled="loading"
                        @click="showDialog = false"
                    >
                        <v-icon small>
                            {{ mdiClose }}
                        </v-icon>
                        Close
                    </v-btn>
                    <v-btn
                        color="teal darken-1"
                        width="120"
                        style="color: white;"
                        type="submit"
                        :loading="loading"
                    >
                        <v-icon small>
                            {{ mdiTrashCan }}
                        </v-icon>
                        Delete
                    </v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import {
    mdiClose,
    mdiTrashCan
} from '@mdi/js'
export default {
    props: ['show', 'data', 'rateItems', 'notif'],
    data: ()=>({
        mdiClose,
        mdiTrashCan,
        form: false,
        loading: false
    }),
    computed: {
        ...mapGetters(['unlinkDiagRateData']),
        showDialog: {
            get() {
                return this.show
            },
            set() {
                this.$emit('closeDialog')
            }
        }
    },
    watch: {
        async unlinkDiagRateData(newVal) {
            if (newVal) {
                if (newVal.status === 200) {
                    this.notif.type = 'success'
                    this.notif.color = 'success'
                    this.notif.timeout = 5000
                    this.notif.msg = 'Link has been deleted.'
                    this.notif.show = true
                    await this.viewLinkedDiagRate({ IS_LINKED_TO: this.data.ID, MSU_C: this.data.MSU_C })
                    this.$emit('refreshMsuRates')
                    this.showDialog = false
                    this.$emit('showIndexPage', { ...this.data, type: this.data.LINKS.length > 0 ? 'show' : 'add' })
                    this.loading = false
                } else {
                    this.notif.type = 'error'
                    this.notif.color = 'error'
                    this.notif.timeout = 5000
                    this.notif.msg = newVal.state
                    this.notif.show = true
                }
            }
        }
    },
    methods: {
        ...mapActions(['unlinkDiagRate', 'viewLinkedDiagRate']),
        submitForm() {
            if (this.$refs.form.validate()) {
                this.loading = true
                const arg = {
                    RATE_ID : this.data.UNLINK_FROM,
                    UNLINK_FROM: this.data.ID,
                    MSU_C: this.data.MSU_C
                }
                this.unlinkDiagRate(arg)
            }
        }
    }
}
</script>
